import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Inflection feature parameters */
export interface InflectionParams {
  /** Reference to parent function element */
  of: string;
}

// =============================================================================
// DEFAULTS
// =============================================================================

/** No additional defaults beyond `of` which must be provided */
export const INFLECTION_DEFAULT_PARAMS: Omit<InflectionParams, 'of'> = {};

/**
 * Default theme for inflection feature.
 * Purple colored points for inflection points.
 */
export const INFLECTION_DEFAULTS: FeatureStyleNode = {
  point: { color: 'purple', fixed: true },
};
